import React from 'react';

const Loader = () => {
    return (
        <div className="loader_wrapper">
            <div id="loader">
                <div id="shadow"></div>
                <div id="box"></div>
                <p>Loading...</p> 
            </div>
        </div>
    );
}

export default Loader;
